import { Outlet } from "react-router";
import Header from "../components/navbar/navbar.component";

const WithNav = () => {
  return (
    <>
      <Header></Header>
      <Outlet />
    </>
  );
};

export default WithNav;
